// extracted by mini-css-extract-plugin
export default {"productGallery":"VJ-z","inQuickShop":"WJ-z"};